// A page's address as it may be kept or sent on: the tracking collector's page and source URLs, and where a new account came from
// (`landing_url` and `referrer` of a signup's source, on the site and on the server). No dependencies, so the site's browser bundle
// takes it as it is.

const EMAIL_LIKE = /[^\s@/?#&=]+@[^\s@/?#&=]+\.[a-z]{2,}/i;

/** The path as a person would read it; a broken escape is read as it stands rather than throwing. */
function readablePath(pathname: string): string {
  try {
    return decodeURIComponent(pathname);
  } catch {
    return pathname;
  }
}

/** An address without its query and fragment, and none at all when it carries a mailbox. Query strings hold tokens and people. */
export function cleanPageUrl(raw: string | null | undefined, options: { originOnly?: boolean } = {}): string | null {
  if (!raw) return null;
  let url: URL;
  try {
    url = new URL(raw);
  } catch {
    return null;
  }
  if (url.protocol !== "https:" && url.protocol !== "http:") return null;
  if (options.originOnly) return `${url.origin}/`;
  if (EMAIL_LIKE.test(readablePath(url.pathname))) return `${url.origin}/`;
  return `${url.origin}${url.pathname}`;
}
